import types from './types'

/**
 * updateTerm
 * @param {string} term
 * @returns {object}
 */
const updateTerm = term => ({
  type: types.SEARCH_ENGINE_UPDATE_TERM,
  payload: { term }
})

/**
 * updateTermList
 * @param {object} data
 * @param {'add'|'remove'} data.method
 * @param {string} data.term
 * @returns {object}
 */
const updateTermList = data => ({
  type: types.SEARCH_ENGINE_UPDATE_TERM_LIST,
  payload: data
})

const updateBackLocation = location => ({
  type: types.SEARCH_ENGINE_UPDATE_BACK_LOCATION,
  payload: { location }
})

export default {
  updateTerm,
  updateTermList,
  updateBackLocation
}
